<div mat-dialog-title>
  <h2 class="mb-0">Bank Statement Transactions</h2>
  <mat-icon class="close" [mat-dialog-close]="true" aria-hidden="false">close</mat-icon>
</div>
<div mat-dialog-content>

  <table mat-table [dataSource]="dataSource" class="alternate-transaction-table">

    <ng-container matColumnDef="postedDate">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element"> {{element.postedDate | date:'shortDate' }} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="trans-desc-col"> Description </th>
      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Amount </th>
      <td mat-cell *matCellDef="let element"> {{element.amount | currency }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</div>
